import React from "react"

import FieldUsers from "../users/users"
import FieldAssignees_GoalListView from "./render/goal-list-view"
import FieldConfig from "../../proto/field-config"

import {GROUP_MISC} from "../../../gd/const/fields/field2-groups"
import FieldAssignees_InlineValueNotEmpty from "./components/inline/value-not-empty"
import FieldAssignees_PickerValueNotEmpty from "./components/picker/value-not-empty"
import FieldAssignees_PopoverMenu from "./components/popover/popover-menu"
import FieldAssignees_PopoverOption from "./components/multiselect/popover-option"
import FieldAssignees_GoalListEditable from "./render/goal-list-editable"
import FieldAssignees_View from "./render/view"
import {FieldFilterType} from "../../proto/types";

export default class FieldAssignees extends FieldUsers {

    public selfUserIsMandatory  : boolean
    public selectionIsMandatory : boolean

    constructor(config: FieldConfig) {

        super(config)
        this.typeLabel              = "Assignees"
        this.filterType             = FieldFilterType.USER
        this.typeGroup              = GROUP_MISC
        this.typeDescription        = "Company user multiple selection field"
        this.icon                   = "i5-user-assigned"

        this.label                  = _.get(config, "label", "Assignees") // is used in picker hint

        this.selfUserIsMandatory    = _.get(config, "selfUserIsMandatory", false)
        this.selectionIsMandatory   = _.get(config, "selectionIsMandatory", false)

        this.noValueOptionLabel     = _.get(config, "noValueOptionLabel", "Not assigned")
        this.placeholder            = _.get(config, "placeholder", "Not assigned")

        this.options = []
        if (!config.options || config.options.length < 1) {

            // In shared view we don't have all users gd.users ... so need filter

            gd.session.companyUsers.filterByCompany(gd.companyId).map((cu: any) => {
                if (cu.user) {
                    // @ts-ignore
                    this.options.push({
                        value: cu.user.id,
                        label: cu.user.name
                    })
                }
            })
        }

        this.components.PopoverMenu             = FieldAssignees_PopoverMenu
        this.components.PopoverOption           = FieldAssignees_PopoverOption
        this.components.InlineValueNotEmpty     = FieldAssignees_InlineValueNotEmpty
        this.components.PickerValueNotEmpty     = FieldAssignees_PickerValueNotEmpty
        this.components.ValueIcon               = <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>

        this.classes.PopoverMenuScrollContainer = 'max-h-200' // to add classes for popover menu scroll container (max-h-200 for example)

        this.renderComponents.goalListEditable  = FieldAssignees_GoalListEditable
        this.renderComponents.goalListView      = FieldAssignees_GoalListView
        this.renderComponents.view              = FieldAssignees_View
    }

    // FieldAssignees specific values -> options
    _getOptions(values:any):any {
        // value is array

        const res: any[] = []
        const options = this.getOptions()
        _.map(values, value=>{
            const option = _.find(options, o=>o.value === value)
            if (option) {
                res.push(option)
            } else {
                res.push({
                    value: value,
                    label: gd.session.users.get(value)?.name
                })
            }
        })

        return !_.isEmpty(res) ? res : false
    }
}
